import {BaseStore} from "../../../stem-core/state/Store.js";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {BaseLogMessage} from "../misc/BaseLogMessage.js";
import {TaskStatus} from "../misc/GenericEnums.js";
import {globalStore} from "../../../stem-core/state/Store.js";
import {MerchantUser} from "./MerchantUserStore";

@globalStore
export class MerchantLogMessage extends BaseStore("MerchantLogMessage", {}, BaseLogMessage) {
    // @ts-ignore
    @field("MerchantUser") user: MerchantUser; // Type is changed from base
    @field("MerchantUser") assignedTo: MerchantUser;
    @field(TaskStatus) status: TaskStatus;
}

export async function apiMerchantEditLogMessage(request: any): Promise<any> {
    return apiClient.post("/merchant/edit_log_message", request);
}

export async function apiMerchantDeleteLogMessage(request: any): Promise<any> {
    return apiClient.post("/merchant/delete_log_message", request);
}
